module.exports = __webpack_public_path__ + "img/better-v.955f2263.svg";